@let contactData = contact();
<aside class="dialog" fxLayout="column">
  <mat-toolbar color="primary">
    <h2 class="dialog__title">
      <div class="title" fxLayout fxLayoutAlign="start center">
        @if (media.isActive('gt-xs')) {
          <qt-avatar
            [name]="contactData.prs.fname"
            [statusCode]="contactData.sts"></qt-avatar>
        }
        <span>{{ contactData.prs.name }}</span>
      </div>
    </h2>
    <span fxFlex></span>
    <button mat-icon-button [matMenuTriggerFor]="menurel" class="m-0">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menurel="matMenu">
      <button mat-menu-item (click)="onEdit()">
        <mat-icon>mode_edit</mat-icon>
        <span>{{ 'CMD_EDIT' | translate }}</span>
      </button>
      <button mat-menu-item (click)="onInvite()">
        <mat-icon>contact_mail</mat-icon>
        <span>{{ 'CMD_CNT_REINVITE' | translate }}</span>
      </button>
    </mat-menu>
    <button mat-icon-button matDialogClose class="m-0">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  <mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="1rem" class="content">
      <h2 class="mat-headline-6">{{ 'GNR_CNT_DETAILS' | translate }}:</h2>
      <div fxLayout="column" fxLayoutGap="1rem" ngClass.gt-xs="px-3">
        @if (contactData.acn?.name?.name) {
          <section
            fxLayout
            fxLayoutGap="1rem"
            fxLayoutAlign="start center"
            [matTooltip]="'FTR_REL_CMP_NAME' | translate"
            matTooltipPosition="above">
            <mat-icon class="material-icon-gray">domain</mat-icon>
            <span class="content__line">{{ contactData.acn.name.name }}</span>
          </section>
        }
        <section
          fxLayout
          fxLayoutGap="1rem"
          fxLayoutAlign="start center"
          [matTooltip]="'GNR_REL' | translate"
          matTooltipPosition="above">
          <mat-icon class="material-icon-gray">swap_horiz</mat-icon>
          <div fxLayout="column">
            <span class="content__line">{{ relation | translate }}</span>
            @if (contactData.rl) {
              <span class="mat-caption">{{ role() | translate }}</span>
            }
          </div>
        </section>
        @if (contactData.acn?.adr && contactData.acn?.adr.adr) {
          <section
            fxLayout
            fxLayoutGap="1rem"
            fxLayoutAlign="start center"
            [matTooltip]="'CMP_ADDRESS' | translate"
            matTooltipPosition="above">
            <mat-icon class="material-icon-gray">place</mat-icon>
            <div fxLayout="column">
              <span class="content__line">{{ contactData.acn.adr.adr }}</span>
              @if (contactData.acn.adr.adr2) {
                <span class="content__line">{{
                  contactData.acn.adr.adr2
                }}</span>
              }
              <span class="content__line">{{
                contactData.acn.adr.city +
                  ' ' +
                  contactData.acn.adr.st +
                  ' ' +
                  contactData.acn.adr.zip
              }}</span>
            </div>
          </section>
        }
        @if (contactData.email) {
          <section
            fxLayout
            fxLayoutGap="1rem"
            fxLayoutAlign="start center"
            [matTooltip]="'GNR_EMAIL' | translate"
            matTooltipPosition="above">
            <mat-icon class="material-icon-gray">email</mat-icon>
            <span class="content__line">{{ contactData.email }}</span>
          </section>
        }
        @if (contactData.prs.phns) {
          <section
            fxLayout="column"
            fxLayoutGap="1rem"
            [matTooltip]="'GNR_PHNNO' | translate"
            matTooltipPosition="above">
            @for (
              phone of contactData.prs.phns;
              track phone;
              let index = $index
            ) {
              <div fxLayout fxLayoutGap="1rem" fxLayoutAlign="start center">
                <mat-icon class="material-icon-gray">{{
                  phone.tp === PhoneType.MOBILE ? 'phone_iphone' : 'phone'
                }}</mat-icon>
                <span>{{ phone.phn | phone: phone.cnty }}</span>
                <!--            <span [ngClass]="{-->
                <!--                content__line: true,-->
                <!--                'content__line&#45;&#45;margin': index !== 0-->
                <!--              }">{{ phone.phn | phone: phone.cnty:true }}</span>-->

                @switch (phone.tp) {
                  @case (100) {
                    <span class="mat-caption">{{
                      'GNR_CELL_PHONE' | translate
                    }}</span>
                  }
                  @case (200) {
                    <span class="mat-caption">{{
                      'GNR_WORK_PHONE' | translate
                    }}</span>
                  }
                  @default {
                    <span class="mat-caption">{{ phone.nck }}</span>
                  }
                }
              </div>
            }
          </section>
        }
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout fxLayoutAlign="end">
    <button mat-button matDialogClose>{{ 'CMD_CLOSE' | translate }}</button>
  </mat-dialog-actions>
</aside>
